import { fiscalDate } from '@makila/fiscal';
import { nextEvent } from './outbox.js';
/** Dia da semana em Maputo: 1 = segunda … 7 = domingo. */
export function isoWeekday(day) {
    const d = new Date(`${day}T12:00:00Z`).getUTCDay();
    return d === 0 ? 7 : d;
}
/** Hoje, em Maputo. */
export const deliveryDay = (now = new Date()) => fiscalDate(now);
/** A rota sai neste dia? (sem dias definidos: todos os dias) */
export const routeRunsOn = (r, day) => !r.weekdays.length || r.weekdays.includes(isoWeekday(day));
/**
 * Paragens de uma rota num dia: os clientes activos dela cujos dias de entrega
 * incluem esse dia (sem dias próprios, seguem os da rota), pela ordem da rota.
 */
export function routeStops(route, customers, day) {
    const wd = isoWeekday(day);
    return customers
        .filter((c) => c.active && c.routeId === route.id)
        .filter((c) => (c.deliveryDays?.length ? c.deliveryDays.includes(wd) : routeRunsOn(route, day)))
        .sort((a, b) => (a.routeOrder ?? 1e9) - (b.routeOrder ?? 1e9) || a.name.localeCompare(b.name, 'pt'));
}
/** Endereço de mapa a partir das coordenadas ("-25.96,32.58"). */
export const mapsLink = (gps) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(gps)}`;
/**
 * Resultado de uma paragem: entregue (com o documento da venda), não estava
 * ou recusou (com o motivo). Vai para a nuvem como evento.
 */
export async function recordStop(store, who, s) {
    if (s.status === 'refused' && !s.reason?.trim())
        throw new RangeError('Diga porque recusou');
    if (s.status === 'delivered' && !s.document)
        throw new RangeError('A entrega leva o documento da venda');
    const now = s.now ?? new Date();
    await store.transaction(async (tx) => {
        await tx.appendOutbox(nextEvent({
            terminalId: who.terminalId, lastSeq: await tx.lastSeq(), type: 'delivery.stop', now,
            payload: {
                routeId: s.routeId, customerId: s.customerId, day: s.day, status: s.status, reason: s.reason?.trim().slice(0, 200) || null,
                document: s.document ?? null, operatorId: s.operatorId, at: now.toISOString(),
            },
        }));
    });
}
//# sourceMappingURL=delivery.js.map